module.exports = __webpack_public_path__ + "img/jiangbei.e9c76f47.png";